import { Phone, Mail, MapPin } from "lucide-react";
import { COMPANY } from "@/data/turboData";

const Contact = () => (
  <div className="pt-16 md:pt-24">
    <div className="mx-auto max-w-7xl px-4 sm:px-6">
      <div className="grid lg:grid-cols-2 gap-12">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-[var(--tt-accent)] font-semibold">
            Contact
          </div>
          <h1 className="font-display text-5xl md:text-6xl font-bold text-[var(--tt-navy)] mt-4 leading-[0.98]">
            Let&apos;s talk shipping.
          </h1>
          <p className="mt-5 text-lg text-[var(--tt-ink-soft)] leading-relaxed max-w-md">
            Questions about a service, custom freight, or a problem with an
            existing shipment? Our team is here.
          </p>

          <div className="mt-9 space-y-5">
            <a href={`tel:${COMPANY.phoneRaw}`} className="flex items-center gap-4 group">
              <span className="h-11 w-11 rounded-xl bg-[var(--tt-accent)]/10 text-[var(--tt-accent)] grid place-items-center group-hover:bg-[var(--tt-accent)] group-hover:text-white transition">
                <Phone className="h-5 w-5" />
              </span>
              <span>
                <div className="text-xs uppercase tracking-wider text-[var(--tt-muted)]">Phone</div>
                <div className="font-semibold text-[var(--tt-navy)]">{COMPANY.phone}</div>
              </span>
            </a>
            <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-4 group">
              <span className="h-11 w-11 rounded-xl bg-[var(--tt-accent)]/10 text-[var(--tt-accent)] grid place-items-center group-hover:bg-[var(--tt-accent)] group-hover:text-white transition">
                <Mail className="h-5 w-5" />
              </span>
              <span>
                <div className="text-xs uppercase tracking-wider text-[var(--tt-muted)]">Email</div>
                <div className="font-semibold text-[var(--tt-navy)]">{COMPANY.email}</div>
              </span>
            </a>
            <div className="flex items-start gap-4">
              <span className="h-11 w-11 rounded-xl bg-[var(--tt-accent)]/10 text-[var(--tt-accent)] grid place-items-center">
                <MapPin className="h-5 w-5" />
              </span>
              <span>
                <div className="text-xs uppercase tracking-wider text-[var(--tt-muted)]">Warehouse &amp; office</div>
                <div className="font-semibold text-[var(--tt-navy)]">{COMPANY.address}</div>
                <div className="text-xs text-[var(--tt-muted)] mt-1">{COMPANY.hours}</div>
              </span>
            </div>
          </div>
        </div>

        <form
          onSubmit={(e) => { e.preventDefault(); alert("Demo only. In Wix this submits to Wix CRM."); }}
          className="card p-7 md:p-8 space-y-4 h-fit"
        >
          <h2 className="font-display text-2xl font-bold text-[var(--tt-navy)]">Send us a message</h2>
          <div className="grid sm:grid-cols-2 gap-3">
            <Input label="Your name" placeholder="Jane Doe" />
            <Input label="Email" placeholder="you@email.com" type="email" />
          </div>
          <Input label="Subject" placeholder="What's this about?" />
          <Textarea label="Message" placeholder="Tell us a bit more…" rows={5} />
          <button type="submit" className="btn-primary w-full justify-center">
            Send message
          </button>
          <p className="text-[11px] text-center text-[var(--tt-muted)]">
            In Wix, this form connects to Wix CRM automatically.
          </p>
        </form>
      </div>
    </div>
  </div>
);

const Input = ({ label, ...rest }) => (
  <label className="block">
    <span className="text-[11px] font-medium uppercase tracking-wider text-[var(--tt-muted)]">{label}</span>
    <input
      {...rest}
      className="mt-1 w-full rounded-xl border border-[var(--tt-line)] bg-white px-3.5 py-3 text-sm outline-none focus:border-[var(--tt-navy)] transition"
    />
  </label>
);

const Textarea = ({ label, ...rest }) => (
  <label className="block">
    <span className="text-[11px] font-medium uppercase tracking-wider text-[var(--tt-muted)]">{label}</span>
    <textarea
      {...rest}
      className="mt-1 w-full rounded-xl border border-[var(--tt-line)] bg-white px-3.5 py-3 text-sm outline-none focus:border-[var(--tt-navy)] transition resize-none"
    />
  </label>
);

export default Contact;
